import { apiStates } from '@/data'

export function removeApiDynamicBusyState(apiBusyStateId: string) {
  const apiBusyState = apiStates()
  delete apiBusyState[apiBusyStateId]
}
